import { groupChapters } from '@/core/media/chapters';
import { engine } from '@/engine/client';

/**
 * The original chapters behind each joined video. The lossless join copies
 * only audio and video, so the camera's GPS track is read from these instead.
 */
const chapterSources = new WeakMap<File, readonly File[]>();

/** Files to read camera telemetry from: the chapters of a joined video, else the video itself. */
export const telemetrySources = (file: File): File[] => [...(chapterSources.get(file) ?? [file])];

/**
 * Turns what the user dropped into the videos to work on: chapters of the same
 * camera recording are joined (losslessly) into one file first.
 */
export async function prepareFiles(files: readonly File[], onProgress: (ratio: number) => void): Promise<File[]> {
  const { recordings, singles } = groupChapters(files);
  const joined: File[] = [];
  for (const [index, recording] of recordings.entries()) {
    const task = engine.joinChapters([...recording.files], `${recording.key}.mp4`, (progress) =>
      onProgress((index + progress.ratio) / recordings.length),
    );
    const file = await task.promise;
    chapterSources.set(file, recording.files);
    joined.push(file);
  }
  return [...joined, ...singles];
}

export const hasChapters = (files: readonly File[]): boolean => groupChapters(files).recordings.length > 0;
